import {Routes} from '@angular/router'
import {Login} from './2-components/login/login'
import {LoggedIn} from './2-components/logged-in/logged-in'

export const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./3-home/routes')
  },
  {
    path: 'users',
    loadChildren: () => import('./4-users/routes')
  },
  {
    path: 'login',
    component: Login
  },
  {
    path: 'logged-in',
    component: LoggedIn
  },
  {
    path: 'authenticated',
    loadComponent: () => import('./2-components/authenticated/authenticated').then(c => c.Authenticated)
  },
  {
    path: 'login-settings',
    loadComponent: () => import('./2-components/login-settings/login-settings').then(c => c.LoginSettings)
  },
  {
    path: 'deploy',
    loadChildren: () => import('./5-deploy/routes')
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/login'
  },
  {
    path: '**',
    redirectTo: 'login'
  }
]
